import { useDraggable } from "@dnd-kit/core";
import { Code } from "@nextui-org/react";

interface AnswerDraggableProps {
  id: string;
  text: string;
}

const AnswerDraggable = (props: AnswerDraggableProps) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id,
  });

  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Code>{props.text}</Code>
    </div>
  );
};

export default AnswerDraggable;
